module.exports = __webpack_public_path__ + "media/end_game1.63f5f057.mp3";